<script>
import webservice from '@/utils/webservice'
export default {
  name: 'PublishCarComponent',
  data () {
    return {
      loading: false,
      carCode: null,
      error: null
    }
  },
  methods: {
    onPressBtnPublishConfirm () {
      let requestLocalTime = new Date().getTime()
      this.loading = true
      webservice.publications.publish(this.carCode).then(response => {
        let onSuccessResult = () => {
          this.$emit('onPublishCar', response)
          this.close()
        }

        let onErrorResult = error => {
          if (error === 'QuotaExceededException') {
            this.error = 'Has superado la cuota máxima de publicaciones, debes liberar huecos antes de publicar este vehículo.'
          } else {
            this.error = error
          }
        }

        let handleResponse = response => {
          this.loading = false
          if (response.success) {
            onSuccessResult()
          } else {
            onErrorResult(response.error)
          }
        }

        let responseLocalTime = new Date().getTime()
        let diffTime = responseLocalTime - requestLocalTime
        if (diffTime < 2000) {
          setTimeout(() => {
            handleResponse(response)
          }, 2000 - diffTime)
        } else {
          handleResponse(response)
        }
      })
    },
    openForCar (carCode) {
      this.reset()
      this.carCode = carCode

      window.$('#modal_publish_car').modal()
    },
    close () {
      window.$('#modal_publish_car').modal('hide')
    },
    reset () {
      this.carCode = null
      this.loading = false
      this.error = null
    }
  }
}
</script>
<template>
  <div>
    <div class="modal fase" role="dialog" id="modal_publish_car">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" v-show="error === null">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4>Publicar vehículo</h4>
          </div>

          <div class="modal-body">
            <div class="center_query" v-if="error === null">
              ¿Quieres publicar este vehículo?
            </div>
            <div  v-if="error !== null">
              <div class="alert alert-danger alert-dismissible">
                <h4><i class="icon fa fa-ban"></i> Error!</h4>
                {{ error }}
              </div>
            </div>
          </div>
          <div class="modal-footer">

            <button type="button" class="btn btn-info" v-bind:class="{disabled: loading}" v-show="error == null" v-on:click="onPressBtnPublishConfirm">
              <span v-if="!loading">Publicar</span>
              <i class="fa fa-refresh fa-spin" v-if="loading"></i>
            </button>

            <button type="button" class="btn btn-default" v-if="error !== null" data-dismiss="modal">Cerrar</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom/PublishCarComponent.vue